import { render, staticRenderFns } from "./_tab_.vue?vue&type=template&id=3777da56&scoped=true&"
import script from "./_tab_.vue?vue&type=script&lang=js&"
export * from "./_tab_.vue?vue&type=script&lang=js&"
import style0 from "./_tab_.vue?vue&type=style&index=0&id=3777da56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777da56",
  null
  
)

export default component.exports